import api, { convertToISODateTime, handleApiError, fetchAllDataRest } from './client';

export const rentalService = {
  /**
   * Get all rentals with pagination and filters
   */
  getAll: async (page = 1, limit = 10, filter = {}) => {
    try {
      const params = {
        page,
        limit,
        userId: filter.userId || undefined,
        rentableItemId: filter.rentableItemId || undefined,
        startDateFrom: filter.startDateFrom ? convertToISODateTime(filter.startDateFrom) : undefined,
        startDateTo: filter.startDateTo ? convertToISODateTime(filter.startDateTo) : undefined,
        searchText: filter.searchText || undefined,
        isActive: filter.isActive !== undefined ? filter.isActive : undefined
      };

      if (filter.exportAll) {
        return await fetchAllDataRest('/api/rentals', params, 'noleggi');
      }

      const response = await api.get('/api/rentals', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching rentals:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nel caricamento dei noleggi')
      };
    }
  },

  /**
   * Get rental by ID
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/rentals/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching rental:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nel caricamento del noleggio')
      };
    }
  },

  /**
   * Get user rentals
   */
  getUserRentals: async (userId, page = 1, limit = 10) => {
    try {
      const response = await api.get(`/api/rentals/user/${userId}`, {
        params: { page, limit }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching user rentals:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nel caricamento dei noleggi dell'utente")
      };
    }
  },

  /**
   * Create new rental
   */
  create: async (rentalData) => {
    try {
      const payload = {
        userId: rentalData.userId,
        rentableItemId: rentalData.rentableItemId,
        quantity: parseInt(rentalData.quantity) || 1,
        startDate: convertToISODateTime(rentalData.startDate),
        expectedReturnDate: rentalData.expectedReturnDate ? convertToISODateTime(rentalData.expectedReturnDate) : null,
        notes: rentalData.notes || null
      };

      const response = await api.post('/api/rentals', payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating rental:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nella creazione del noleggio')
      };
    }
  },

  /**
   * Update rental
   */
  update: async (id, rentalData) => {
    try {
      const payload = {
        quantity: rentalData.quantity ? parseInt(rentalData.quantity) : null,
        startDate: rentalData.startDate ? convertToISODateTime(rentalData.startDate) : null,
        expectedReturnDate: rentalData.expectedReturnDate ? convertToISODateTime(rentalData.expectedReturnDate) : null,
        actualReturnDate: rentalData.actualReturnDate ? convertToISODateTime(rentalData.actualReturnDate) : null,
        notes: rentalData.notes !== undefined ? rentalData.notes : null
      };

      const response = await api.put(`/api/rentals/${id}`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating rental:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'aggiornamento del noleggio")
      };
    }
  },

  /**
   * Return rental
   */
  return: async (id, returnDate = null) => {
    try {
      const payload = {
        actualReturnDate: returnDate ? convertToISODateTime(returnDate) : null
      };

      const response = await api.post(`/api/rentals/${id}/return`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error returning rental:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nella restituzione del noleggio')
      };
    }
  },

  /**
   * Delete rental
   */
  delete: async (id) => {
    try {
      await api.delete(`/api/rentals/${id}`);
      return { success: true };
    } catch (error) {
      console.error('Error deleting rental:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'eliminazione del noleggio")
      };
    }
  }
};

export default rentalService;
